import {
  exampleSavedAudience,
  SavedAudience,
} from '../ad-builder/audience/SavedAudience';

export interface BusinessWithDefaultAudiences {
  businessID: number;
  businessName: string;
  audiences: SavedAudience[];
}

export const exampleBusinessWithDefaultAudiences: BusinessWithDefaultAudiences = {
  businessID: 1,
  businessName: 'Test Business',
  audiences: [exampleSavedAudience],
};
